import {
  SupabaseService,
  SupabaseServiceView,
} from "../../../server/supabase/base-supabase-service";

import type { Database } from "../../../__definitions__/database-definitions";
import type { GetAllOptions } from "../../../server/supabase/base-supabase-service";
import type { UUID } from "../../../utils/uuid";

export type ReviewStatus =
  Database["public"]["Tables"]["moment_review_log"]["Row"]["review_status"];

export type MomentReviewLogEntry = Database["public"]["Tables"]["moment_review_log"]["Row"];

/** Where a Communication's review got to, worked out by the database. */
export type MomentReviewState = Database["public"]["Views"]["moment_review_state"]["Row"];

export interface ReviewStep {
  moment_id: UUID;
  review_status: ReviewStatus;
  reviewer_person_id?: UUID | null;
  note?: string | null;
}

export class SupabaseMomentReviewLogService extends SupabaseService<"moment_review_log"> {
  table = "moment_review_log" as const;

  // The log only holds a moment_id, so join the moments view for the title and the current
  // moment/review status.
  getAllWithMoment(account_id: UUID, options: GetAllOptions<MomentReviewLogEntry>) {
    return this.getAllFromSelection(
      account_id,
      this.client
        .from(this.table)
        .select(
          "moment_id, created_at, note, user_name, review_status, moment:moments!moment_review_log_account_id_moment_id_fkey(title, status)",
        ),
      options,
    );
  }

  /** Every review step and comment for one Communication, oldest first. */
  async getThread(account_id: UUID, moment_id: UUID): Promise<MomentReviewLogEntry[]> {
    const { data, error } = await this.getAll(account_id, {
      order: [{ column: "created_at", dir: "asc" }],
      filter: [{ key: "moment_id", operator: "eq", value: moment_id }],
    });
    if (error) throw error;
    return data;
  }
}

export class SupabaseMomentReviewStateService extends SupabaseServiceView<"moment_review_state"> {
  table = "moment_review_state" as const;
}
